/**
 * Conteúdo da aba Ajuda — agregador.
 *
 * Cada arquivo é uma seção; a ordem aqui é a ordem na tela. Manter o conteúdo
 * como dados puros (strings, sem JSX): é a futura base de conhecimento da Cleo
 * quando esta aba virar conversa.
 */
import { primeirosPassos } from "./primeirosPassos";
import { vendas } from "./vendas";
import { cardapio } from "./cardapio";
import { chatbot } from "./chatbot";
import { impressao } from "./impressao";
import { financeiro } from "./financeiro";
import { marketing } from "./marketing";
import { gestao } from "./gestao";

export const SECOES_AJUDA = [
  primeirosPassos,
  vendas,
  cardapio,
  chatbot,
  impressao,
  financeiro,
  marketing,
  gestao,
];
